import { render, staticRenderFns } from "./teclist.vue?vue&type=template&id=128337b0"
import script from "./teclist.vue?vue&type=script&lang=js"
export * from "./teclist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports